<template>
  <b-modal
    size="lg"
    :hideFooter="true"
    :hideHeader="true"
    id="userEditModal"
  >
    <template slot="default">
      <b-container>
        <b-row class="userModal-header">
          <b-col sm="12">
            <h5>
              <em class="far fa-edit"></em> Редактирование пользователя
            </h5>
          </b-col>
        </b-row>
        <b-row class="userModalItem">
          <b-col sm="3">
            <label> E-mail: </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id='email' v-model="chosenUser.email" type='email' maxlength="100"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="userModalItem">
          <b-col sm="3">
            <label> Фамилия: </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id='surname' v-model="chosenUser.surname" type='text' maxlength="100"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="userModalItem">
          <b-col sm="3">
            <label> Имя: </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id='name' v-model="chosenUser.name" type='text' maxlength="100"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="userModalItem">
          <b-col sm="3">
            <label> Отчество: </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id='midname' v-model="chosenUser.midname" type='text' maxlength="100"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="userModalItem">
          <b-col sm="3">
            <label> Организация: </label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea
              id='organisation'
              v-model="chosenUser.organisation.title"
              disabled type='text'
            >
            </b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3">
            <label> Последнее изменение: </label>
          </b-col>
          <b-col sm="9">
            <div> {{ new Date(chosenUser.passwordReset).toLocaleString() }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <label> Роли: </label>
          </b-col>
          <b-col sm="9" id="rolesCheckBoxGroup">
            <b-form-checkbox-group v-model="chosenUser.roles" stacked required>
              <b-form-checkbox
                v-for="(role, index) in allRoles"
                :disabled="chosenUser.roles.includes(roles_.student) || role === roles_.student
                        || ( role === roles_.admin && chosenUser.initialRoles.includes(roles_.admin))"
                :key="index"
                :value="role"
              > {{ $_userMixin_roleTranslate(role) }} </b-form-checkbox>
            </b-form-checkbox-group>
            <p v-show="chosenUser.roles.length === 0" class="userEditModal__rolesWarning">
              <span> Пользователь должен обладать как минимум одной ролью </span>
            </p>
          </b-col>
        </b-row>
        <b-row class="mb-3 sm userModal-footer">
          <b-col sm="12" md="6" class="ml-auto sm p-3">
            <b-btn
              id="saveButton"
              variant="primary"
              class="float-right userModal-confirmButton"
              :disabled="chosenUser.roles.length === 0"
              @click="saveUser"
            >
              <em class="fas fa-check"></em> Сохранить изменения
            </b-btn>
          </b-col>
          <b-col sm="12" md="6" class="ml-auto sm p-3">
            <b-btn
              variant="outline-primary"
              class="float-right userModal-confirmButton"
              @click="$bvModal.hide('userEditModal')"
            >
              <em class="fas fa-times"></em> Отменить изменения
            </b-btn>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserMixin from '@/components/helpers/mixins/user-mixin'
import { roles } from '@/config/roles'
import { regexp } from '@/config/regexp'

export default {
  name: 'UserEditModal',
  mixins: [UserMixin],
  props: {
    chosenUser: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      roles_: roles,
      allRoles: Object.values(roles),
      nameRegExp: regexp.name
    }
  },
  computed: {
    ...mapGetters('dicts', {
      rolesIds: 'getRoles'
    })
  },
  methods: {
    ...mapActions('toasts', [
      'pushToasts'
    ]),
    saveUser() {
      if (!this.chosenUser.name.match(this.nameRegExp)) {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Некорректный ввод имени!'
        })
        return
      }

      if (!this.chosenUser.surname.match(this.nameRegExp)) {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Некорректный ввод фамилии!'
        })
        return
      }

      if (this.chosenUser.midname && !this.chosenUser.midname.match(this.nameRegExp)) {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Некорректный ввод отчества!'
        })
        return
      }
      const roles = []
      this.rolesIds.forEach((el) => {
        if (this.chosenUser.roles.includes(el.title)) {
          roles.push(el.id)
        }
      })
      const user = {
        id: this.chosenUser.id,
        name: this.chosenUser.name,
        surname: this.chosenUser.surname,
        midname: this.chosenUser.midname || null,
        email: this.chosenUser.email,
        roles
      }
      this.$emit('saveUser', user)
    }
  }
}
</script>

<style scoped>

</style>
